import { render, staticRenderFns } from "./orientationModuleAssignmentListing.vue?vue&type=template&id=7803b476&"
import script from "./orientationModuleAssignmentListing.vue?vue&type=script&lang=js&"
export * from "./orientationModuleAssignmentListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports